import React, { useCallback, useContext, useRef, useState } from 'react';
import styled from 'styled-components';
import { ConfirmationModal, FlexColumn, Button } from '@ubeya/shared-web/components';
import SignatureCanvas from 'react-signature-canvas';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  gap: 16px;
  .sigCanvas {
    border: 1px solid ${({ theme }) => theme.colors.grey2};
    width: 100%;
    height: 100%;
  }
`;

const SignatureContainer = styled(FlexColumn)`
  gap: 4px;
  width: 100%;
`;

const ClientTimesheetApprovalSignatureModal = ({ onClose, handleClientApprove }) => {
  const { t } = useContext(ConfigContext);
  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);

  let signatureCanvasRef = useRef();

  const onApprove = useCallback(async () => {
    await handleClientApprove({ signature: signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png') });

    onClose();
  }, [handleClientApprove, onClose]);

  const onClear = useCallback(() => {
    signatureCanvasRef.current.clear();
    setIsSignatureEmpty(true);
  }, []);

  const handleSignatureChange = () => {
    setIsSignatureEmpty(signatureCanvasRef.current.isEmpty());
  };

  return (
    <>
      <ConfirmationModal
        onConfirm={onApprove}
        usePortal
        onClose={onClose}
        title={t('timesheetApprovalSignature')}
        disabledConfirm={isSignatureEmpty}
        confirmText="approve">
        <Container>
          <SignatureContainer>
            <SignatureCanvas
              ref={signatureCanvasRef}
              penColor="black"
              throttle={10}
              onEnd={handleSignatureChange}
              canvasProps={{ className: 'sigCanvas' }}
            />
          </SignatureContainer>
          <Button tertiary narrow onClick={onClear} disabled={isSignatureEmpty}>
            {t('clearSignature')}
          </Button>
        </Container>
      </ConfirmationModal>
    </>
  );
};

export default ClientTimesheetApprovalSignatureModal;
